import { DOCUMENT_CATEGORY_LABELS } from './document-category-labels';

/**
 * German-canonical copy printed into generated documents. The PDF is always rendered `de-DE`.
 */
export const documents = {
  'signature-pages': {
    'signatures-heading': 'Unterschriften',
    'role-agency': 'für {companyName}',
    'role-owner': 'Eigentümer',
    'signed-at': 'Elektronisch unterschrieben am {date} um {time} Uhr',
    'signatures-footer': 'Unterschriften · Seite {page}',
    'proof-heading': 'Nachweis',
    'proof-email': 'E-Mail: {email}',
    'proof-signed': 'Unterschrieben: {date} {time} ({zone})',
    'proof-ip': 'IP-Adresse: {ip}',
    'proof-browser': 'Browser: {userAgent}',
    'proof-browser-unknown': 'unbekannt',
    'proof-early-start': 'Vorzeitiger Beginn verlangt: {value, select, yes {ja} other {nein}}',
    'proof-fingerprint': 'Dokument-Fingerabdruck (SHA-256): {hash}',
    'proof-footer': 'Nachweis · Seite {page}',
  },
  'deal-document': {
    months: '{months, plural, one {# Monat} other {# Monate}}',
    'broker-representation':
      '{count, plural, one {den bevollmächtigten Makler {names}} other {die bevollmächtigten Makler {names}, jeweils einzeln vertretungsberechtigt}}',
    'page-number': 'Seite {page} / {pages}',
    'footer-separator': ' · ',
    'signed-suffix': 'unterschrieben',
    type: {
      BROKER_CONTRACT: DOCUMENT_CATEGORY_LABELS.BROKER_CONTRACT,
      POWER_OF_ATTORNEY: DOCUMENT_CATEGORY_LABELS.POWER_OF_ATTORNEY,
    },
  },
} as const;
